export default __webpack_public_path__ + "static/media/bra_details1.e906269a.webp";